import sendToServer from './send-to-server';
import Answers from './answers';
import KeyTerms from './key-terms';

const TasterQuizFunctionality = {
  init() {
    if (!($('.taster-quiz').length > 0)) return;

    $('.popup .closer').click(this.handleClosePopupClick.bind(this));
    $('.explainer-overlay').click(this.handleOverlayClick.bind(this));
    $('.topic-add-button').click(this.handleTopicAddClick.bind(this));
    $('.selectable').click(this.handleSelectableClick.bind(this));
    $('.next-question').click(this.handleNextQuestionClick.bind(this));

    KeyTerms.init();
    Answers.init(this, KeyTerms);
  },

  handleClosePopupClick() {
    $('.popup').hide();
  },

  handleOverlayClick() {
    $('.explainer-overlay').fadeOut();
  },

  onAnswerSubmission(postAnswerSubmission) {
    $('.early-escape').hide();
    postAnswerSubmission();
  },

  handleTopicAddClick(event) {
    const $button = $(event.target).closest('.topic-add-button');

    const onResponse = ()=> { $button.fadeOut() };

    sendToServer('/api/v2/topic_preferences',
                  { tag_id: $button.data('tag-id') },
                  onResponse);
  },

  handleSelectableClick(event) {
    const $button = $(event.target).closest('.selectable');
    $button.toggleClass('selected');
  },

  handleNextQuestionClick() {
    const likedTopicIds = [];
    const likedCareerIds = [];
    const combinedIds = [];

    $('.selectable.selected').toArray().forEach((element) =>{
      const $element = $(element);
      const careerId = $element.data('career-id');
      const tagId = $element.data('tag-id');
      if (careerId) {
        likedCareerIds.push(careerId);
        combinedIds.push({ type: 'career', id: careerId})
      }
      if (tagId) {
        likedTopicIds.push(tagId);
        combinedIds.push({ type: 'tag', id: tagId})
      }
    });

    const actions = [];

    if (likedTopicIds.length > 0) {
      actions.push((n)=> {
        sendToServer('/api/v2/topic_preferences',
                    { tag_ids: likedTopicIds },
                    () => { nextAction(n + 1) })
      });
    }

    if (likedCareerIds.length > 0) {
      actions.push((n)=> {
        sendToServer('/api/v2/career_preferences',
                    { career_ids: likedCareerIds },
                    () => { nextAction(n + 1) });
      });
    }

    const finalAction = ()=> {
      if (combinedIds.length > 0) {
        const item = combinedIds[Math.floor(Math.random()*combinedIds.length)];
        const prefix = '/app/taster?previous_question_id=' + $('.question-box').data('question-id') + '&link_to_previous=';

        if (item.type === 'career') {
          window.location = prefix + 'career';
        } else {
          window.location = prefix + 'topic&tag_id=' + item.id;
        }
      } else {
        window.location = '/app/taster?link_to_previous=completely_different&previous_question_id=' + $('.question-box').data('question-id');
      }
    }

    const nextAction = (n) => {
      if (actions[n]) {
        actions[n](n);
      } else {
        finalAction();
      }
    }

    if (actions.length > 0) {
      nextAction(0);
    } else {
      finalAction();
    }

    $('.next-panel').slideUp();
  },
};

$(document).ready(()=> {
  TasterQuizFunctionality.init();
});
